import { Box, Paper } from '@mui/material';
import { Suspense, useState } from "react";
import { useSelector } from "react-redux";
import DocumentViewer from '../../../../../components/admin/FileOpener/FileViewer';
import LoaderText from '../../../../../components/loader/LoaderText';

const ViewPolicyDocument = () => {
  const { drawerData: uploadDocumentFiles } = useSelector((state: any) => state.drawer);
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box sx={{ width: "100%" }}>
      <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: "calc(100vh - 59px)" }}>
        <Box sx={{ flexGrow: 1 }}>
          {uploadDocumentFiles && Array.isArray(uploadDocumentFiles) && uploadDocumentFiles?.length > 0 && (
            <Box sx={{ height: "100%", padding: 2 }}>
              <Suspense fallback={<LoaderText />}>
                {uploadDocumentFiles?.map((fileUrl: any, index: number) => (
                    <Box key={index} sx={{ height: "100%", display: tabIndex === index ? 'block' : 'none' }}>
                      <DocumentViewer filePath={fileUrl?.document_path || fileUrl?.file_path} />
                    </Box>
                  )
                )}
              </Suspense>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default ViewPolicyDocument;
